import React from 'react';
import { Paper, Typography, Box, Button, Tooltip } from '@mui/material';
import ChecklistIcon from '@mui/icons-material/Checklist';
import ClearIcon from '@mui/icons-material/Clear';

interface WorkflowBulkActionsProps {
  selectedCount: number;
  onClearSelection: () => void;
  onBulkStatusChange: () => void;
  disabled?: boolean;
}

/**
 * WorkflowBulkActions - Toolbar for bulk operations on selected batches.
 * Single Responsibility: ONLY renders the bulk action toolbar UI
 */
export const WorkflowBulkActions: React.FC<WorkflowBulkActionsProps> = ({
  selectedCount,
  onClearSelection,
  onBulkStatusChange,
  disabled = false,
}) => {
  return (
    <Paper
      elevation={3}
      sx={(theme) => ({
        p: 2, mb: 2, display: 'flex', alignItems: 'center', gap: 2,
        bgcolor: 'primary.50', borderLeft: 4, borderColor: 'primary.main', flexWrap: 'wrap',
        ...theme.applyStyles('dark', { bgcolor: 'primary.900' }),
      })}
    >
      <Typography variant="body1" sx={{ fontWeight: 500 }}>
        {selectedCount} batch{selectedCount !== 1 ? 'es' : ''} selected
      </Typography>

      <Box sx={{ flex: 1 }} />

      <Tooltip title={disabled ? 'Select batches to enable' : 'Change status for selected batches'}>
        <span>
          <Button
            variant="outlined"
            size="small"
            disabled={disabled}
            startIcon={<ChecklistIcon />}
            onClick={() => onBulkStatusChange()}
            aria-label="Change status for selected batches"
          >
            Change Status
          </Button>
        </span>
      </Tooltip>

      <Button size="small" onClick={onClearSelection} startIcon={<ClearIcon />} aria-label="Clear selection">
        Clear
      </Button>
    </Paper>
  );
};

export default WorkflowBulkActions;
